import {
  Compass, Utensils, Coffee, Wine, Beef, Bed, ShoppingBag, ShoppingCart,
  Pill, HeartPulse, Fuel, CreditCard, Landmark, TreePalm, Camera,
  GraduationCap, Book, Dumbbell, Film, SquareParking, Zap, Theater,
  Images, Binoculars, TrainFront, Stethoscope, Shield, Flame, Mail, House,
  Bath, Droplets, Recycle, Baby, Trophy, Waves, Umbrella, PawPrint, Bike,
  Wrench, Ship, CarTaxiFront,
} from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export const categoryIcons: Record<string, LucideIcon> = {
  restaurant: Utensils,
  cafe: Coffee,
  bar: Wine,
  'fast-food': Beef,
  hotel: Bed,
  hostel: Bed,
  shop: ShoppingBag,
  supermarket: ShoppingCart,
  pharmacy: Pill,
  hospital: HeartPulse,
  'gas-station': Fuel,
  atm: CreditCard,
  bank: Landmark,
  park: TreePalm,
  museum: Landmark,
  attraction: Camera,
  school: GraduationCap,
  library: Book,
  gym: Dumbbell,
  cinema: Film,
  parking: SquareParking,
  charging: Zap,
  theatre: Theater,
  gallery: Images,
  'historic-site': Landmark,
  viewpoint: Binoculars,
  'transit-station': TrainFront,
  clinic: Stethoscope,
  dentist: HeartPulse,
  police: Shield,
  'fire-station': Flame,
  'post-office': Mail,
  shelter: House,
  'public-toilet': Bath,
  'drinking-water': Droplets,
  recycling: Recycle,
  playground: Baby,
  'sports-centre': Trophy,
  'swimming-pool': Waves,
  beach: Umbrella,
  zoo: PawPrint,
  'bicycle-rental': Bike,
  'bicycle-repair': Wrench,
  'ferry-terminal': Ship,
  taxi: CarTaxiFront,
};

export function getCategoryIcon(slug: string): LucideIcon {
  return categoryIcons[slug] || Compass;
}
